export async function validateFiles(
  files,
  maxFiles = 5,
  options = {
    image: {
      allowedTypes: ["image/jpeg", "image/png", "image/gif", "image/webp"],
      maxSizeMB: 15,
    },
    video: { allowedTypes: ["video/mp4", "video/quicktime"], maxSizeMB: 512 },
  }
) {
  const errors = [];
  const { image, video } = options;

  if (files.length > maxFiles) {
    errors.push(`You can upload a maximum of ${maxFiles} files at a time.`);
  }

  for (const file of files) {
    const isImage = image.allowedTypes.includes(file.type);
    const isVideo = video.allowedTypes.includes(file.type);
    const sizeMB = file.size / 1024 / 1024;

    if (!isImage && !isVideo) {
      errors.push(
        `File "${file.name}" has an unsupported format. Allowed formats: Images (${image.allowedTypes.join(", ")}), Videos (${video.allowedTypes.join(", ")}).`
      );
    }

    if (isImage && sizeMB > image.maxSizeMB) {
      errors.push(
        `Image "${file.name}" exceeds the maximum size of ${image.maxSizeMB} MB.`
      );
    }

    if (isVideo && sizeMB > video.maxSizeMB) {
      errors.push(
        `Video "${file.name}" exceeds the maximum size of ${video.maxSizeMB} MB.`
      );
    }

    if (
      (isImage && sizeMB < image.maxSizeMB) &&
      (isVideo && sizeMB < video.maxSizeMB)
    ) {
      const isFileBroken = await checkIfBroken(file);
      if (isFileBroken) {
        errors.push(`File "${file.name}" is empty or corrupted.`);
      }
    }
  }

  return errors;
}

async function checkIfBroken(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();

    if (file.size === 0) {
      resolve(true);
      return;
    }

    reader.onload = () => {
      const result = reader.result;

      if (!result || result.byteLength === 0) {
        resolve(true);
      } else {
        resolve(false);
      }
    };

    reader.onerror = () => {
      resolve(true);
    };

    try {
      reader.readAsArrayBuffer(file);
    } catch (err) {
      resolve(true);
    }
  });
}
